<ion-header>
  <ion-toolbar>
    <ion-input
      #reportNameInput
      placeholder="Board Name"
      [(ngModel)]="reportName"
      class="title-input"
      (ionBlur)="onNameChange()"
    ></ion-input>
    <ion-buttons slot="end">
      <ion-button
        (click)="toggleTvMode()"
        class="button-dark-border"
        [hidden]="!isReadOnly"
        [disabled]="isLoading"
      >
        <ion-icon
          [name]="isTvMode ? 'close-outline' : 'tv-outline'"
          slot="start"
        ></ion-icon>
        {{ isTvMode ? "Exit TV Mode" : "TV Mode" }}
      </ion-button>
      <ion-button
        (click)="copyLink()"
        class="button-dark-border"
        [disabled]="isLoading"
        *ngIf="boardId && isReadOnly"
      >
        <ion-icon name="link-outline" slot="start"></ion-icon>
        Share link
      </ion-button>
      <ion-button
        (click)="deleteBoard()"
        class="button-dark-border"
        [disabled]="isLoading"
        *ngIf="boardId && !isReadOnly"
      >
        <ion-icon name="trash-outline" slot="start" color="danger"></ion-icon>
        Delete
      </ion-button>
      <ion-button
        (click)="toggleEditMode()"
        class="button-dark-border"
        [disabled]="isLoading"
      >
        <ion-icon
          [name]="isReadOnly ? 'create-outline' : 'eye-outline'"
          slot="start"
        ></ion-icon>
        {{ isReadOnly ? "Edit" : "Preview" }}
      </ion-button>
      <ion-button
        *ngIf="!isReadOnly"
        (click)="save()"
        class="button-dark-border"
        [disabled]="isLoading"
      >
        <ion-icon name="save" class="filter-button-icon"></ion-icon>
        <span class="hidden-sm">Save...</span>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- Rows container with drag and drop -->
  <div class="board-container">
    <div
      [cdkDropListDisabled]="isReadOnly"
      cdkDropList
      [cdkDropListData]="rows"
      (cdkDropListDropped)="dropRow($event)"
      [ngClass]="{ 'rows-container': !isReadOnly }"
    >
      <div
        *ngFor="let row of rows; let rowIndex = index"
        [cdkDragDisabled]="isReadOnly"
        cdkDrag
        [ngClass]="{ 'row-item': !isReadOnly }"
        (click)="!isReadOnly && selectRow(row)"
      >
        <div class="row-header" *ngIf="!isReadOnly">
          <div class="row-title">
            <ion-icon
              *ngIf="!isReadOnly"
              name="menu"
              class="drag-handle"
              cdkDragHandle
            ></ion-icon>
            Row {{ rowIndex + 1 }}
          </div>
          <div class="row-actions" *ngIf="!isReadOnly">
            <ion-button
              size="small"
              fill="clear"
              (click)="addColumn(row)"
              [hidden]="row.columns.length >= 6"
              [disabled]="isLoading"
            >
              <ion-icon
                name="add-circle-outline"
                class="padded-icon"
              ></ion-icon>
              <span class="hidden-sm">Add column</span>
            </ion-button>
            <ion-button
              size="small"
              fill="clear"
              (click)="deleteRow(rowIndex)"
              [disabled]="isLoading"
            >
              <ion-icon name="trash-outline"></ion-icon>
            </ion-button>
          </div>
        </div>

        <!-- Columns container with drag and drop -->
        <div
          [cdkDropListDisabled]="isReadOnly"
          cdkDropList
          [cdkDropListData]="row.columns"
          [id]="'columns-' + row.id"
          [cdkDropListConnectedTo]="getConnectedLists()"
          (cdkDropListDropped)="dropColumn($event, row)"
          class="columns-container"
          [style.display]="'flex'"
          [style.flex-wrap]="'wrap'"
        >
          <div
            *ngFor="let column of row.columns; let colIndex = index"
            [cdkDragDisabled]="isReadOnly"
            cdkDrag
            [cdkDragData]="column"
            [style.flex-basis.%]="column.width"
            [style.padding.px]="8"
          >
            <!-- Fix for preview when dragging - use ng-template with ngIf -->
            <ng-template [ngIf]="!isReadOnly">
              <div *cdkDragPreview class="column-drag-preview">
                {{ column.title }}
              </div>
            </ng-template>

            <!-- Fix for placeholder when dragging - use ng-template with ngIf -->
            <ng-template [ngIf]="!isReadOnly">
              <div *cdkDragPlaceholder class="column-drag-placeholder"></div>
            </ng-template>

            <ion-card class="column-card">
              <ion-card-header>
                <ion-card-title>
                  <div class="column-header">
                    <div class="column-title">
                      <ion-icon
                        *ngIf="!isReadOnly"
                        name="custom-drag-vertical"
                        class="drag-handle"
                        cdkDragHandle
                      ></ion-icon>
                      <ion-icon
                        name="lock-closed"
                        *ngIf="
                          savedReportLookup[column.savedReportId] &&
                          savedReportLookup[column.savedReportId].userIds
                            ?.length
                        "
                        ngxTippy
                        [tippyProps]="{
                          content: 'This report is private to you',
                          placement: 'bottom',
                          touch: false,
                          arrow: false
                        }"
                      ></ion-icon>
                      {{
                        savedReportLookup[column.savedReportId]?.name ??
                          "No report selected"
                      }}
                      <a
                        (click)="openReportInNewTab(column.savedReportId)"
                        *ngIf="isReadOnly"
                        style="margin-left: 8px"
                      >
                        <ion-icon name="open-outline"></ion-icon>
                      </a>
                    </div>
                    <div class="column-actions">
                      <!-- Remove the display options button from here -->
                      <!--
                    <ion-button
                      *ngIf="isReadOnly"
                      size="small"
                      fill="clear"
                      class="item-accessory-button"
                      (click)="showColumnDisplayOptions(column)"
                    >
                      <ion-icon name="options-outline"></ion-icon>
                    </ion-button>
                    -->

                      <ion-button
                        size="small"
                        fill="clear"
                        (click)="deleteColumn(row, colIndex)"
                        [disabled]="isLoading"
                        class="item-accessory-button"
                        *ngIf="!isReadOnly"
                      >
                        <ion-icon name="trash-outline"></ion-icon>
                      </ion-button>
                    </div>
                  </div>
                </ion-card-title>
              </ion-card-header>
              <ion-card-content>
                <div *ngIf="!isReadOnly" class="column-content">
                  <ion-button
                    fill="clear"
                    size="full"
                    class="btn-large"
                    [color]="column.savedReportId ? 'dark' : 'primary'"
                    (click)="chooseSavedReport(column)"
                    [disabled]="isLoading"
                  >
                    <ion-icon
                      [name]="
                        column.savedReportId
                          ? 'pencil-outline'
                          : 'add-circle-outline'
                      "
                      class="padded-icon"
                    ></ion-icon>
                    {{
                      column.savedReportId &&
                      savedReportLookup[column.savedReportId]
                        ? savedReportLookup[column.savedReportId].name
                        : "Choose a report"
                    }}
                  </ion-button>

                  <!-- Add display options in edit mode when a report is selected -->
                  <div *ngIf="column.savedReportId" class="display-options">
                    <div class="pill-tab-container">
                      <div
                        class="round-pill-tab round-pill-tab-left"
                        [ngClass]="{
                          'round-pill-tab-active': !column.showTable
                        }"
                        style="font-size: 0.7rem"
                        (click)="column.showTable = false"
                      >
                        Chart
                      </div>
                      <div
                        class="round-pill-tab round-pill-tab-right"
                        [ngClass]="{
                          'round-pill-tab-active': column.showTable
                        }"
                        style="font-size: 0.7rem"
                        (click)="column.showTable = true"
                      >
                        Table
                      </div>
                    </div>
                  </div>

                  <ion-item
                    *ngIf="column.savedReportId && !column.showTable"
                    lines="none"
                    class="transparent-bg"
                  >
                    <ion-label>Show Legend</ion-label>
                    <ion-toggle
                      [(ngModel)]="column.showLegend"
                      slot="end"
                    ></ion-toggle>
                  </ion-item>
                </div>

                <!-- Replace the chart rendering with our updated component -->
                <app-chart
                  *ngIf="
                    isReadOnly &&
                    column.savedReportId &&
                    savedReportLookup[column.savedReportId]
                  "
                  [savedReportId]="column.savedReportId"
                  [savedReport]="savedReportLookup[column.savedReportId]"
                  [showLegend]="
                    column.showLegend !== undefined ? column.showLegend : true
                  "
                  [showTable]="
                    column.showTable !== undefined ? column.showTable : false
                  "
                ></app-chart>

                <div
                  *ngIf="isReadOnly && !column.savedReportId"
                  class="no-report-selected"
                >
                  Try editing and selecting a report
                </div>
              </ion-card-content>
            </ion-card>
          </div>
        </div>
      </div>

      <!-- Only show "Add Row" button in edit mode -->
      <div class="row-item" *ngIf="!isReadOnly">
        <ion-button
          fill="clear"
          size="full"
          (click)="addRow()"
          class="btn-large no-margin"
          [disabled]="isLoading"
        >
          <ion-icon name="add-circle-outline" class="padded-icon"></ion-icon>
          Add Row
        </ion-button>
      </div>
    </div>
  </div>
</ion-content>
